import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		token: null,
		user: null,
		refresh: null,
	},
	mutations: {
		[MUTATIONS.USER.LOGIN](state, { user, token }) {
			state.token = token
			state.user = user
			state.refresh = new Date()
		},
		[MUTATIONS.USER.UPDATE](state, { email, firstname, lastname }) {
			state.user.lastname = lastname
			state.user.firstname = firstname
			state.user.email = email
		},
		[MUTATIONS.USER.LOGOUT](state) {
			state.token = null
			state.user = null
			state.refresh = null
		},
	},
	actions: {
		[ACTIONS.USER.LOGIN]({ commit, dispatch, state }, { email, password }) {
			return API.USER.SIGNIN(email, password).then(res => {
				commit(MUTATIONS.USER.LOGIN, res)
				return res
			})
		},

		[ACTIONS.USER.UPDATE](
			{ commit, dispatch, state },
			{ id, email, firstname, lastname },
		) {
			return API.USER.UPDATE(id, email, firstname, lastname).then(res => {
				commit(MUTATIONS.USER.UPDATE, { id, email, firstname, lastname })
				return res
			})
		},

		[ACTIONS.USER.PASSWORD]({ commit, dispatch, state }, { id, password }) {
			return API.USER.PASSWORD(id, password).then(res => {
				return res
			})
		},

		[ACTIONS.USER.AVATAR]({ commit, dispatch, state }, { id, file }) {
			return API.USER.AVATAR(id, file).then(res => {
				return res
			})
		},

		[ACTIONS.USER.LOGOUT]({ commit, dispatch, state }) {
			commit(MUTATIONS.USER.LOGOUT)
		},
	},

	getters: {
		getCurrentUser: state => state.user,
		getCurrentToken: state => state.token,
		getRefresh: state => state.refresh,
		isAdmin: state => state.user && state.user.typeId === 1,
	},
}
